module.exports = __webpack_public_path__ + "static/media/wordmark.8b94ec57.svg";